/**
 * @file 学习资料页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import Learningmaterials from './learningmaterials';

import './style.less';



ReactDOM.render(<Learningmaterials />, document.getElementById('root'));


